'use es6';

import { NONE, LAYOUT, TEMPLATE, CUSTOM_WIDGET, GLOBAL_WIDGET, GLOBAL_GROUP, SETTINGS, FOLDER } from 'DesignData/enums/DesignAssetTypes';
export default Object.freeze({
  [NONE]: 'code'
  /* TEMPLATE */
  ,
  [LAYOUT]: 'dragAndDropLayout'
  /* PAGE */
  ,
  [TEMPLATE]: 'code'
  /* TEMPLATE */
  ,
  [CUSTOM_WIDGET]: 'customModules'
  /* TEMPLATE */
  ,
  [GLOBAL_WIDGET]: 'globalGroup'
  /* GLOBAL */
  ,
  [GLOBAL_GROUP]: 'partial'
  /* GLOBAL */
  ,
  [SETTINGS]: 'settings'
  /* GLOBAL */
  ,
  [FOLDER]: 'folderOpen'
});